import _extends from "@babel/runtime/helpers/extends";
import { useCallback, useEffect, useState } from "react";
import { toString } from "../../utils/deterministic-string";
import useFetch from "./use-fetch";

var usePost = function usePost(_ref) {
  var cacheAndNetwork = _ref.cacheAndNetwork,
      cacheType = _ref.cacheType,
      invalidatorTime = _ref.invalidatorTime,
      request = _ref.request,
      _ref$skipCall = _ref.skipCall,
      skipCall = _ref$skipCall === void 0 ? true : _ref$skipCall,
      using = _ref.using,
      willUpdate = _ref.willUpdate;

  var _useState = useState({
    invalidatorTime: invalidatorTime,
    skipCall: skipCall,
    using: using
  }),
      state = _useState[0],
      setState = _useState[1];

  var _useFetch = useFetch(_extends({
    cacheAndNetwork: cacheAndNetwork,
    cacheType: cacheType,
    invalidatorTime: invalidatorTime,
    request: request,
    skipCall: skipCall,
    using: using,
    willUpdate: willUpdate
  }, state)),
      fetchState = _useFetch[0];

  useEffect(function () {
    setState({
      invalidatorTime: invalidatorTime,
      skipCall: skipCall,
      using: using
    });
  }, [invalidatorTime, request, skipCall, toString(using)]);
  return [fetchState, useCallback(function (useVal) {
    setState({
      invalidatorTime: Date.now(),
      skipCall: false,
      using: useVal
    });
  }, []), state.using];
};

usePost.STATUSES = useFetch.STATUSES;
usePost.CACHE_TYPES = useFetch.CACHE_TYPES;
usePost.STATE_RESET = useFetch.STATE_RESET;
export default usePost;